import React from 'react'
import Button from './Button'
import { Card, Status } from './ui'

const LOGOS = { bitrix24: 'B24', amocrm: 'amo' }
const STATUS = {
  active: { label: 'подключён', tone: 'success' },
  pending: { label: 'Подключается', tone: 'warning' },
  error: { label: 'Ошибка подключения', tone: 'error' },
  reauth_required: { label: 'Требуется переподключение', tone: 'error' }
}

export default function SourceCard ({
  connector,
  connection,
  disconnecting = false,
  onConnect,
  onOpen,
  onDisconnect
}) {
  const state = connection
    ? STATUS[connection.status] || STATUS.error
    : { label: 'требует подключения', tone: 'neutral' }
  const canOpen = connection?.status === 'active'
  const canReconnect = ['error', 'reauth_required'].includes(connection?.status)
  const canDisconnect = connection?.status !== 'pending' && (
    Number.isInteger(connection?.id) || connection?.id === 'amocrm-legacy'
  )
  const accountLabel = connection?.display_name || (connection ? 'подключение не завершено' : 'не подключён')

  return (
    <Card className='source-card' aria-label={connector.name}>
      <div className='source-card__top'>
        <div className='source-card__identity'>
          <div className='source-card__logo' data-connector={connector.slug} aria-hidden='true'>
            {LOGOS[connector.slug] || connector.slug.slice(0, 2).toUpperCase()}
          </div>
          <div className='source-card__body'>
            <h2>{connector.name}</h2>
            <div className='source-card__account' title={connection?.display_name || accountLabel}>
              {accountLabel}
            </div>
          </div>
        </div>
        <Status tone={state.tone}>{state.label}</Status>
      </div>
      {connection?.error_message && connection.status !== 'active' && (
        <div className='source-card__error'>{connection.error_message}</div>
      )}

      <div className='source-card__actions'>
        {!connection && <Button variant='stroke' onClick={onConnect}>Подключить</Button>}
        {canOpen && <Button variant='stroke' onClick={onOpen}>Перейти к коннектору →</Button>}
        {canReconnect && <Button variant='stroke' onClick={onConnect}>Переподключить</Button>}
        {canDisconnect && (
          <Button
            variant='ghost'
            loading={disconnecting}
            aria-label={`Отключить ${connector.name}`}
            onClick={onDisconnect}
          >
            Отключить
          </Button>
        )}
      </div>
    </Card>
  )
}
